export enum GraphTypes {
    bestfit,
    stevensSchutzbach,
}
